import { CloudOSDeploymentEnvironment } from "@/types/shared/CloudOSDeploymentEnvironment";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig() || {
  publicRuntimeConfig: {
    NEXT_PUBLIC_DEPLOYMENT_ENVIRONMENT: "development"
  }
};

export const PAGE = {
  HOME: "Home",
  MY_JOBS: "My Jobs",
  ALL_JOBS: "All Jobs",
  MY_RELEASES: "My Releases",
  ALL_RELEASES: "All Releases",
  RELEASES: "Releases",
  MY_NOTARIZATIONS: "My Notarizations",
  ALL_NOTARIZATIONS: "All Notarizations",
  NOTARIZATIONS: "Notarizations",
  ADMIN: "Debug Dashboard",
  /** Manifest landing (`/manifest`) */
  MANIFEST: "Manifest",
  /** Single manifest record (`/manifest/<upi2>` or catch-all segments) */
  MANIFEST_VIEW: "Manifest View",
  /** Manifest editor (`/manifest/<upi2>/edit`) */
  MANIFEST_EDIT: "Manifest Edit",
  /** Manifest activation (`/manifest/activate`) */
  MANIFEST_ACTIVATE: "Manifest Activate",
  /** Manifest auto-update (`/manifest/autoupdate`) */
  MANIFEST_AUTO_UPDATE: "Manifest Auto Update",
  MY_ITEMS: "My Items",
  ALL_ITEMS: "All Items",
  ITEMS: "Create New Item",
  JOB_PROFILES: "Job Profiles",
  CREATE_JOB_PROFILE: "Create Job Profile",
  BTD: "BTD Dashboard",
  FORBIDDEN: "Forbidden",
  CHANNEL_BUILDS: "Channel Builds",
  ALL_ENGINE_CONFIG: "Engine Configuration",
  MY_ENGINE_CONFIG: "My Engine Configuration",
  SUBMIT_ENGINE_CONFIG: "Add Product Mapping",
  ENGINE_CONFIG_PUBLISHED: "Published Config"
};

export function getEnvSuffix() {
  const deploymentEnvironment = publicRuntimeConfig.NEXT_PUBLIC_DEPLOYMENT_ENVIRONMENT as CloudOSDeploymentEnvironment;
  const validEnvironments: CloudOSDeploymentEnvironment[] = ["development", "staging", "production"];
  const isValidEnvironment = validEnvironments.includes(deploymentEnvironment);

  const environment = isValidEnvironment ? deploymentEnvironment : "development";
  let baseURL = "-dev";

  switch (environment) {
    case "development":
      baseURL = "-dev";
      break;
    case "staging":
      baseURL = "-stg";
      break;
    case "production":
      baseURL = "";
      break;
    default:
  }
  return baseURL;
}

export const getCurrentUri = () => {
  switch (window.location.pathname) {
    case "/jobs/myjob":
      return PAGE.MY_JOBS;
    case "/jobs":
      return PAGE.ALL_JOBS;
    case "/releases/myrelease":
      return PAGE.MY_RELEASES;
    case "/releases":
      return PAGE.ALL_RELEASES;
    case "/submitrelease":
      return PAGE.RELEASES;
    case "/notarization/mynotarization":
      return PAGE.MY_NOTARIZATIONS;
    case "/notarization":
      return PAGE.ALL_NOTARIZATIONS;
    case "/submitnotarization":
      return PAGE.NOTARIZATIONS;
    case "/item/myitem":
      return PAGE.MY_ITEMS;
    case "/item":
      return PAGE.ALL_ITEMS;
    case "/submititem":
      return PAGE.ITEMS;
    case "/jobProfiles":
      return PAGE.JOB_PROFILES;
    case "/submitJobProfile":
      return PAGE.CREATE_JOB_PROFILE;
    case "/admin":
      return PAGE.ADMIN;
    case "/manifest":
      return PAGE.MANIFEST;
    case "/manifest/view":
      return PAGE.MANIFEST_VIEW;
    case "/manifest/edit":
      return PAGE.MANIFEST_EDIT;
    case "/manifest/activate":
      return PAGE.MANIFEST_ACTIVATE;
    case "/manifest/autoupdate":
      return PAGE.MANIFEST_AUTO_UPDATE;
    case "/btd":
      return PAGE.BTD;
    case "/channel-builds":
      return PAGE.CHANNEL_BUILDS;
    case "/forbidden":
      return PAGE.FORBIDDEN;
    case "/engineconfig":
      return PAGE.ALL_ENGINE_CONFIG;
    case "/engineconfig/myproduct":
      return PAGE.MY_ENGINE_CONFIG;
    case "/submitengineconfig":
      return PAGE.SUBMIT_ENGINE_CONFIG;
    case "/engineconfig/published":
      return PAGE.ENGINE_CONFIG_PUBLISHED;
    default:
      return PAGE.HOME;
  }
};

/** True when the app runs in the browser on a local dev host. */
export function isAppRunningOnLocalhost(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]";
}
